import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../workers/WorkerCategories.css";
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { IDoorstepCategory, ISubCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import Paginator from "src/components/layout/Paginator";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import LoadingGif from "src/components/layout/Loader";
interface InitialValuesType {
   category_name: string;
   description: string;
   icon: string | null;
   provider: string[];

}

const getAllDoorstepCategories = async (token: string, pageNumber: number, searchValue: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         search_value: searchValue,
         pageSize: 20
      }
   })
};
const getAllSubCategories = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/sub-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         pageSize: 100
      }
   })

};

const DoorstepCategories = () => {
   const initialValues: IDoorstepCategory = {
      category_name: "",
      description: "",
      icon: null,
      provider: [],
      createdAt: "",
      _id: "",

   };

   const loading = useAppSelector(state => state?.loading?.value)
   const Token = Cookies.get("token");
   const [subCats, setSubCats] = useState<ISubCategory[]>([]);
   const [editMode, setEditMode] = useState(false);
   const [modalShow, setModalShow] = useState(false);
   const [searchVal, setSearchVal] = useState("");
   const [selectedCategory, setSelectedCategory] = useState<IDoorstepCategory | null>(null);
   const [doorstepCategories, setDoorstepCategories] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [totalPages, setTotalPages] = useState(0);
   const animatedComponents = makeAnimated();
   const [confirmDel, setConfirmDel] = useState(false);
   const dispatch = useAppDispatch();

   useEffect(() => {
      dispatch(startLoading());
      getAllDoorstepCategories(Token as string, pageNo, searchVal).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setDoorstepCategories(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages)
         } else {
            Swal.fire({
               icon: "error",
               title: "Something went wrong!!",
               text: `${res?.data?.data?.msg}`,

            });
         }
      }).catch(err => console.log(err)).finally(() => dispatch(stopLoading()))
   }, [Token, pageNo, searchVal, modalShow, confirmDel])

   useEffect(() => {
      if (Token) {
         getAllSubCategories(Token).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data?.data)
               setSubCats(res?.data?.data?.data)
            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }

   }, [Token]);


   const [inputs, setInputs] = useState(initialValues);

   const validationSchema = yup.object().shape({
      category_name: yup.string()
         .required('Please Fill this field (Category Name).'),

      description: yup.string()
         .required('Please Fill this field (Description).'),
      provider: yup.mixed().required("Please Fill this Field (Provider)."),
      icon: yup.mixed().required('Please upload an Icon.'),
   });

   const onCreate = () => {
      setEditMode(false);
      setModalShow(true);
      setInputs({
         ...inputs,
         category_name: "",
         description: "",
         icon: null,
         provider: [],
         createdAt: "",
         _id: "",

      })
      setSelectedCategory({
         category_name: "",
         description: "",
         icon: null,
         provider: [],
         createdAt: "",
         _id: "",
      })
   }
   const onHide = () => {
      setModalShow(false);
      setEditMode(false);
      // setInputs(initialValues);
   }

   const onUpdate = (id: string) => {
      const valuesToEdit = doorstepCategories.find((value: IDoorstepCategory) => value._id === id);
      setSelectedCategory(valuesToEdit);

      // Populate the form fields with the existing data
      setInputs({
         ...inputs,
         category_name: valuesToEdit?.category_name,
         description: valuesToEdit?.description,
         icon: valuesToEdit?.icon,
         provider: valuesToEdit?.provider,
         createdAt: valuesToEdit?.createdAt,
         _id: valuesToEdit?._id,
      });

      setEditMode(true);
      setModalShow(true);
   };

   const handleDeleteConfirmed = (id: string) => {
      // console.log(id);
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      // Dispatch the delete action here

      Swal.fire({
         title: 'Are you sure?',
         text: "You won't be able to revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!'
      }).then(async (response) => {

         if (response.isConfirmed) {
            // console.log("lamao")
            dispatch(startLoading());
            await axios({
               url: `${AppConfig.DEV_SERVER}/doorStep-category/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res?.data?.status_code)
               if (res?.data?.status_code === 200) {
                  setConfirmDel(!confirmDel)
                  Swal.fire(
                     'Deleted!',
                     `${res?.data?.msg}`,
                     'success'
                  );
               }
               else {
                  Swal.fire(
                     `Something Went Wrong!`,
                     `${res?.data?.msg}`,
                     'error'
                  )
               }

            }).catch((err) => {
               console.log(err)
            })  // Clear the selectedFoodItem state after updating
               .finally(() => {
                  dispatch(stopLoading());
               })
            setModalShow(false);
         }
      }
      )
   };


   const handleFormSubmit = async (formInput: any, resetForm: () => void) => {
      const formData = new FormData();

      formData.append('category_name', formInput?.category_name);
      formData.append('description', formInput?.description);
      // console.log("inside-form: ", selectedCategory?.provider)
      Object.values(selectedCategory?.provider as string[]).map((data, key) => {
         formData.append('provider', data);
      })
      if (formInput.icon != "" && formInput.icon != undefined) {
         formData.append('icon', formInput?.icon);
      }

      // console.log(formInput);
      if (!Token) return;

      if (!editMode) {
         // Add new food item
         // console.log("lol")
         dispatch(startLoading());
         await axios({
            url: `${AppConfig.DEV_SERVER}/doorStep-category`,
            method: "POST",
            data: formData,
            headers: {
               'content-type': 'multipart/form-data',
               "x-access-token": Token,
            }
         }).then((res) => {
            // console.log(res?.data?.status_code)
            if (res?.data?.status_code === 201) {

               Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Success!",
                  text: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 2500
               });
               resetForm();
            }
            else {
               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: `Oops....`,
                  text: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 3500
               });
               resetForm();
            }

            setModalShow(false);
         }).catch((err) => {
            console.log(err);
         }).finally(() => {
            dispatch(stopLoading());
         })


      } else {
         if (selectedCategory != null) {
            if (selectedCategory?._id) {
               formData.append("category_id", selectedCategory?._id)
               // console.log(selectedCategory);
               await axios({
                  url: `${AppConfig.DEV_SERVER}/doorStep-category/${selectedCategory?._id}`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then((res) => {

                  setModalShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     text: `${res?.data?.msg}`,
                     title: `Success!`,
                     showConfirmButton: false,
                     timer: 4500
                  });
                  resetForm();
               }).catch((err) => {
                  console.log(err);
               }).finally(() => {
                  dispatch(stopLoading());
               })

            }
         } else {
            console.error("Selected food item or its ID is undefined.");
         }
      }
   }
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   return (
      <MainLayout searchValue={searchVal} onChange={(e) => setSearchVal(e.target.value)} clearValChange={clearSearchValue}>
         <Formik
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
               handleFormSubmit(values, resetForm)
            }}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={inputs}
         >
            {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
               <Modal show={modalShow} onHide={() => onHide()} size="lg" className="rounded-9 category-modal">
                  <Form noValidate onSubmit={handleSubmit}>
                     <Modal.Header closeButton>
                        <Modal.Title as="h5">{editMode ? 'Update Category' : 'Add Category'}</Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                        <Row className="fieldset-row" >
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="icon">Icon</Form.Label>

                              <Form.Control name="icon" type="file" onChange={(event: any) => {
                                 const file = event.currentTarget.files[0];
                                 // console.log(file);
                                 setFieldValue("icon", file);
                              }} isValid={touched.icon && !errors.icon} isInvalid={!!errors.icon} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.icon}
                              </Form.Control.Feedback>
                           </Col>
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="category_name">Doorstep Category Name</Form.Label>
                              <Form.Control id="category_name" type='text' onChange={handleChange} name="category_name" isValid={touched.category_name && !errors.category_name} value={values.category_name} isInvalid={!!errors.category_name} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.category_name}
                              </Form.Control.Feedback>
                           </Col>
                           <Col md={12} className="mb-b">
                              <Form.Label htmlFor="provider">Providers Name</Form.Label>
                              <Select
                                 className="slect-div"
                                 closeMenuOnSelect={false}
                                 components={animatedComponents}
                                 name="provider"
                                 isMulti
                                 onChange={(selectedOptions) => {
                                    const setValues = selectedOptions?.map(data => data?.value)
                                    // console.log("selectedOptions: ", selectedOptions, "setValues: ", setValues)
                                    setSelectedCategory({
                                       ...selectedCategory as IDoorstepCategory,
                                       provider: setValues as string[]
                                    })
                                 }}
                                 defaultValue={selectedCategory?.provider?.map(data => ({ label: data, value: data }))}
                                 options={subCats?.map(data => ({ label: data?.sub_category_name, value: data?.sub_category_name }))}

                              />
                           </Col>
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="description">Description</Form.Label>
                              <Form.Control id="description" type='text' onChange={handleChange} name="description" isValid={touched.description && !errors.description} value={values.description} isInvalid={!!errors.description} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.description}
                              </Form.Control.Feedback>
                           </Col>

                        </Row>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button variant="app-warning" type="submit" className="ps-4 pe-4 add-cat-btn">
                           {editMode ? 'Update Category' : 'Add Category'}
                        </Button>
                     </Modal.Footer>
                  </Form>
               </Modal>
            )
            }
         </Formik >
         <div className="main-div">
            <div className="card category-main me-2 p-3 p-md-4">
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }
               <div className="d-flex justify-content-end mb-2" >

                  <div className="d-flex justify-content-end gap-4 w-md-50 ">
                     <span className="add-cat" onClick={() => onCreate()}>
                        <button className="add-cat-btn"> Add Category </button>
                     </span>
                     {/* <SearchBar width="50%" value={searchValue} onInputChange={(e) => setSearchValue(e?.target?.value)} /> */}
                  </div>
                  {/* <SearchBar width="20%" value={searchValue} onInputChange={(e) => setSearchValue(e?.target?.value)} /> */}
               </div>
               <div className="table-extra-responsive">
                  <table className="table table-striped card-body">
                  <thead>
                     <tr className="category-tr">
                        {/* <th scope="col" className="text-start ps-4">name</th> */}
                           <th scope="col" className=" text-start ps-4">Doorstep Category Id</th>
                           <th scope="col" className=" text-start ps-4 ">Category Name</th>
                           <th scope="col" className="  text-start ps-4">Applicable Providers</th>

                        <th scope="col" className=" text-start ps-4">Icon</th>
                        <th scope="col" className=" cat_btns">Action</th>
                     </tr>
                  </thead>
                  <tbody>
                     {
                           doorstepCategories && doorstepCategories?.map((data: IDoorstepCategory) => (
                           <tr key={data?._id}>
                              {/* <th scope="row" className="text-start ps-4 pt-3">{data?.position}</th> */}
                                 <td className=" text-start ps-4 pt-3" width="20%">{data?._id}</td>
                              <td className=" text-start ps-4 pt-3" width="20%">{data?.category_name}</td>
                              <td className=" text-start ps-4 pt-3" width="40%">{data?.provider.join(", ")}</td>

                              <td className=" icon-td text-start ps-4" width="10%">
                                 <img src={data?.icon as string} alt="categories" style={{ height: "50px", width: "70px" }} />
                              </td>

                              <td className="align-content-center ">
                                    <div className="d-flex justify-content-center gap-3">
                                    <button className="btn btn-sm edit_btn" onClick={() => onUpdate(data._id)} style={{ marginBottom: "1px" }}>
                                       <img src={editIcon} />
                                    </button>
                                    {/* <button className="btn btn-sm delete_btn ">
                                       <img src={eye} />
                                    </button> */}
                                    <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                       <img src={deleteIcon} />
                                    </button>
                                 </div>

                              </td>

                           </tr>
                        ))
                     }


                  </tbody>
               </table>
               </div>

               <Paginator
                  totalPages={totalPages}
                  pageNo={pageNo}
                  onPageChange={(e, no) => setPageNo(no)}
                  alignment="right"
               />
            </div>
         </div>

      </MainLayout>
   )
};

export default DoorstepCategories;